module.exports = __webpack_public_path__ + "img/Voice-BG-img.8fa84778.jpg";